<template>
  <div>
    <p class="mb-10"><strong class="fs-12">Podřízený spolupracovník</strong></p>
    <div class="collaborator-overflow">
      <div class="collaborator-head">
        <div class="spacer-add"></div>
        <span>Jméno a příjmení</span>
        <div class="spacer-btn"></div>
        <span class="ml-3" v-if="!makler">Certifikace</span>
        <span :class="{ 'ml-3': makler }">Pozice</span>
        <span>Vlastní</span>
        <span v-if="!makler">Strukturní</span>
        <span v-if="!makler">Celkem</span>
      </div>
      <div v-for="n in items">
        <div class="collaborator-item">
          <v-btn color="orange" icon outline small @click="n.detail=!n.detail" v-if="n.spolupracovnici.length>0"><v-icon v-if="!n.detail">add</v-icon><v-icon v-else>remove</v-icon></v-btn>
          <!-- <img src="@/assets/images/logo-cc.svg" alt="Jméno a příjmení"> -->
          <span :class="{ 'ml-3': n.spolupracovnici.length > 0, 'ml-4 pl-2': n.spolupracovnici.length == 0 }">{{n.nazev_osoby}}</span>
          <v-btn color="orange" class="elevation-0 bold ma-0 mx-4" @click="openDialog(n.id)" small dark><v-icon>remove_red_eyes</v-icon> Detail</v-btn>
          <span v-if="!makler">
            <v-icon class="text-green" small v-if="n.certifikovan">check_circle_outline</v-icon>
            <v-icon class="text-red" small v-else>highlight_off</v-icon>
          </span>
          <span>{{n.pozice}}</span>
          <span>{{n.vlastni_kredity | formatInt}} kr.</span>
          <span v-if="!makler">{{n.skupinove_kredity | formatInt}} kr</span>
          <span v-if="!makler">{{n.celkem_kredity | formatInt}} kr</span>
        </div>
        <div class="collaborator-item__sub" v-if="n.spolupracovnici.length>0 && n.detail">
          <spolupracovnici-podrizeni :items="n.spolupracovnici" :makler="makler"></spolupracovnici-podrizeni>
        </div>
      </div>
    </div>

    <v-dialog
      v-model="dialogSpolupracovnici"
      scrollable
      max-width="800px"
      transition="dialog-transition"
      v-if="dialogSpolupracovnici"

    >
      <v-flex xs12>
        <v-card>
          <v-card-title class="pa-0">
            <h2>Detail spolupracovníka</h2>
          </v-card-title>
          <v-card-text class="pa-0 mt-3">
            <div class="account pa-1">
              <v-layout row wrap>
                <v-flex xs12 sm6 md4 class="mb-20">
                  <p class="grey--text caption mb-1 bold">
                    <span v-if="moje_udaje.typ_osoby == 'po'">Název firmy:</span>
                    <span v-else>Jméno a příjmení:</span>
                  </p>
                  <strong v-if="moje_udaje.nazev_osoby">{{ moje_udaje.nazev_osoby }}</strong>
                  <strong v-else>--</strong>
                </v-flex>
                <v-flex xs12 sm6 md4 class="mb-20" v-if="moje_udaje.typ_osoby == 'po'">
                  <p class="grey--text caption mb-1 bold">Jméno jednatele:</p>
                  <strong v-if="moje_udaje.jmeno && moje_udaje.prijmeni">{{moje_udaje.jmeno}} {{moje_udaje.prijmeni}}</strong>
                  <strong v-else-if="moje_udaje.jmeno">{{moje_udaje.jmeno}}</strong>
                  <strong v-else-if="moje_udaje.prijmeni">{{moje_udaje.prijmeni}}</strong>
                  <strong v-else>--</strong>
                </v-flex>
                <v-flex xs12 sm6 md4 class="mb-20">
                  <p class="grey--text caption mb-1 bold">Telefon:</p>
                  <strong v-if="moje_udaje.telefon">{{moje_udaje.telefon}}</strong>
                  <strong v-else>--</strong>
                </v-flex>
                <v-flex xs12 sm6 md4 class="mb-20">
                  <p class="grey--text caption mb-1 bold">E-mail:</p>
                  <strong v-if="moje_udaje.email"><a :href="'mailto:'+moje_udaje.email">{{moje_udaje.email}}</a></strong>
                  <strong v-else>--</strong>
                </v-flex>
                <v-flex xs12 sm6 md4 class="mb-20">
                  <p class="grey--text caption mb-1 bold">Kraj:</p>
                  <strong v-if="moje_udaje.kraj != null">{{moje_udaje.kraj.nazev}}</strong>
                  <strong v-else>--</strong>
                </v-flex>
                <v-flex xs12 sm6 md4 class="mb-20" v-if="moje_udaje.typ_osoby != 'fo'">
                  <p class="grey--text caption mb-1 bold">IČ:</p>
                  <strong v-if="moje_udaje.ic">{{moje_udaje.ic}}</strong>
                  <strong v-else>--</strong>
                </v-flex>
                <v-flex xs12 sm6 md4 class="mb-20" v-if="moje_udaje.typ_osoby != 'fo'">
                  <p class="grey--text caption mb-1 bold">DIČ:</p>
                  <strong v-if="moje_udaje.dic">{{moje_udaje.dic}}</strong>
                  <strong v-else>--</strong>
                </v-flex>
              </v-layout>
              <hr class="account__hr">
              <v-layout row wrap>
                <v-flex xs12 sm6 md4 class="mb-20" v-if="!makler">
                  <p class="grey--text caption mb-1 bold">Certifikace:</p>
                  <v-icon class="text-green" small v-if="moje_udaje.certifikovan">check_circle_outline</v-icon>
                  <v-icon class="text-red" small v-else>highlight_off</v-icon>
                </v-flex>
                <v-flex xs12 sm6 md4 class="mb-20">
                  <p class="grey--text caption mb-1 bold">Pozice:</p>
                  <strong v-if="moje_udaje.pozice">{{ moje_udaje.pozice }}</strong>
                  <strong v-else>--</strong>
                </v-flex>
              </v-layout>
              <hr class="account__hr">
              <v-layout row wrap>
                <v-flex xs12 sm6 md4 class="mb-20">
                  <p class="grey--text caption mb-1 bold">Vlastní kredity:</p>
                  <strong v-if="moje_udaje.pozice">{{ moje_udaje.vlastni_kredity | formatMoney }} kr.</strong>
                  <strong v-else>--</strong>
                </v-flex>
                <v-flex xs12 sm6 md4 class="mb-20" v-if="!makler">
                  <p class="grey--text caption mb-1 bold">Strukturní kredity:</p>
                  <strong v-if="moje_udaje.pozice">{{ moje_udaje.skupinove_kredity | formatMoney }} kr.</strong>
                  <strong v-else>--</strong>
                </v-flex>
                <v-flex xs12 sm6 md4 class="mb-20">
                  <p class="grey--text caption mb-1 bold" v-if="!makler">Celkem kredity:</p>
                  <p class="grey--text caption mb-1 bold" v-else>Celkem kredity od začátku spolupráce:</p>
                  <strong v-if="moje_udaje.pozice">{{ moje_udaje.celkem_kredity | formatMoney }} kr.</strong>
                  <strong v-else>--</strong>
                </v-flex>
              </v-layout>
            </div>
          </v-card-text>
          <v-card-actions class="mt-3 pa-0">
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-3 elevation-0" class="bold" @click="dialogSpolupracovnici=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-dialog>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        detail: false,
        dialogSpolupracovnici: false,
        moje_udaje: {},
        spolupracovnik_id: null
      };
    },
    props: {
      items: Array,
      makler: Boolean
    },
    computed: {
      me: function() {
        return window.$me;
      }
    },
    mounted () {

    },
    methods: {
      openDialog (v) {
        this.moje_udaje = {};
        window.API.get("obchody/spolupracovnici/" + v).then(function(body) {
          this.moje_udaje = body;
          this.dialogSpolupracovnici = true;
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      }
    }
  }
</script>
